<template>
  <figure v-if="data.classNames && data.classNames.indexOf('gallery') > -1" :class="data.classNames" :style="'background-color: '+data.styles_background_colour+';'">
    <div>
      <img v-if="data.images.length" :src="data.images[0].url" class="gallery-item-spacer" />
      <div v-if="image.url" v-for="image in data.images" class="inner-fill gallery-item" v-bind:style="{ backgroundImage:'url('+image.url+')' }"></div>
    </div>
  </figure>
  <figure v-else-if="data.images && data.classNames && (data.classNames.indexOf('fixed-bg') > -1 || data.classNames.indexOf('full-screen') > -1)" :class="data.classNames" v-bind:style="{ backgroundImage:'url('+data.images[0].url+')' }">
    <figcaption v-if="data.images.length && data.images[0].caption">{{ data.images.length && data.images[0].caption }}</figcaption>
  </figure>
  <figure v-else-if="data.images" :class="data.classNames" :style="'background-color: '+data.styles_background_colour+';'">
    <div v-for="image in data.images">
      <img :src="image.url" />
      <figcaption v-if="image.caption">{{ image.caption }}</figcaption>
    </div>
  </figure>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'ImageBlock',
  props: ['data']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ImageBlock.vue